module.exports = __webpack_public_path__ + "img/main5.c10e7a3e.png";